import { getEventSuffix } from '../helpers/utils';

export const SET_METRICS_PROPERTIES = 'SET_METRICS_PROPERTIES';
export const SET_METRICS_PARAMS = 'SET_METRICS_PARAMS';
export const SET_METRICS_READY = 'SET_METRICS_READY';
export const SEND_PAGEVIEW = 'SEND_PAGEVIEW';
export const SEND_CUSTOM_EVENT = 'SEND_CUSTOM_EVENT';
export const RESET_USER_METRICS = 'RESET_USER_METRICS';
export const SEND_KM_SET = 'SEND_KM_SET';
export const SEND_TRANSACTION_EVENT = 'SEND_TRANSACTION_EVENT';
export const SEND_KM_IDENTIFY = 'SEND_KM_IDENTIFY';
export const SEND_ACTION_EVENT = 'SEND_ACTION_EVENT';
export const SEND_GA4_METRICS = 'SEND_GA4_METRICS';

export function setProperties(properties) {
  return {
    type: SET_METRICS_PROPERTIES,
    metrics: properties,
    receivedProps: true
  };
}
export function setParams(params = '') {
  return {
    type: SET_METRICS_PARAMS,
    params
  };
}

export function setMetricsReady(ready) {
  return {
    type: SET_METRICS_READY,
    ready
  };
}

export function sendPageview(data) {
  return {
    type: SEND_PAGEVIEW,
    data
  };
}

export function sendCustomEvent(name, data, dontFilter = false) {
  return {
    type: SEND_CUSTOM_EVENT,
    event: getEventSuffix(name),
    data,
    dontFilter
  };
}

export function sendActionEvent(name, data, dontFilter = false) {
  return {
    type: SEND_ACTION_EVENT,
    event: name,
    data,
    dontFilter
  };
}

export function sendKMSet(data = {}) {
  return {
    type: SEND_KM_SET,
    data
  };
}

export function sendKMIdentify(data = {}) {
  return {
    type: SEND_KM_IDENTIFY,
    data
  };
}

export function resetUserMetrics() {
  return {
    type: RESET_USER_METRICS,
    data: {}
  };
}

export function sendTransactionEvent(name, data) {
  return {
    type: SEND_TRANSACTION_EVENT,
    event: getEventSuffix(name),
    data
  };
}

export function sendGA4Metrics(eventName, offer = false) {
  return {
    type: SEND_GA4_METRICS,
    eventName,
    offer
  };
}
